import { combineReducers } from "redux";
import getPropertiesReducer from "./propertiesReducer";

const propertiesReducer = combineReducers({
    properties: getPropertiesReducer,
});

export default propertiesReducer;